import { Box, Typography, Container, Button } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import VideoRecorder from "react-video-recorder";

const commonInstructionStyle = {
  marginBottom: { xs: "10px", sm: "20px" },
};

export const Recorder = ({
  heading,
  body,
  setVideo,
  onSubmit,
  allowManualSubmission,
}) => {
  const uploadRef = React.useRef(null);
  const [loading, setLoading] = useState(false);
  const [isUploadLocal, setUploadLocal] = useState(false);
  const height =
    window.innerHeight > window.innerWidth
      ? Math.max(280, window.innerWidth - 150)
      : Math.min(450, window.innerHeight - 370);

  useEffect(() => {
    if (isUploadLocal && onSubmit) {
      setLoading(true);
      onSubmit();
    }
    else setLoading(false);
  }, [isUploadLocal, onSubmit]);

  const onVideoSubmit = () => {
    setLoading(true);
    onSubmit();
  };

  const uploadDirectly = () => uploadRef.current?.click();
  const onUploadVideo = (event) => {
    const { files } = event.target;
    if (files && files.length > 0) {
      const target = files[0];
      setLoading(true);
      const fReader = new FileReader();
      fReader.readAsDataURL(target);
      fReader.onloadend = async () => {
        setVideo(target);
        setUploadLocal(true);
      };
    }
  };

  const getInsturction = (text, variant) => (
    <Typography variant={variant || "body1"} sx={commonInstructionStyle}>
      {text}
    </Typography>
  );

  return (
    <Container
      maxWidth="100%"
      sx={{
        flexDirection: "column",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        margin: "30px 0",
      }}
    >
      <Typography variant="h1" sx={{ fontSize: { xs: "4rem", sm: "6rem" } }}>
        {heading}
      </Typography>
      <Typography
        variant="body1"
        sx={{ fontSize: { xs: "1.5rem", sm: "2rem" } }}
        textAlign="center"
        marginBottom="20px"
      >
        {body}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flex: 1,
          flexDirection: { xs: "column-reverse", sm: "row" },
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: "12px",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            div: { marginBottom: 0 },
            'div[class*="video-recorder__Wrapper"]': {
              width: height,
              height,
              borderRadius: "50%",
              minHeight: height,
            },
            marginRight: { sm: "40px" },
            marginTop: { xs: "20px", sm: 0 },
            video: { transform: "translate(-50%,-50%) scaleX(-1)" },
            'div[class*="timer__Text"]': {
              display: "flex",
              alignItems: "center",
            },
          }}
        >
          <VideoRecorder
            constraints={{
              audio: true,
              video: { width: { ideal: 2160 }, height: { ideal: 2160 } },
            }}
            onRecordingComplete={setVideo}
          />
          {allowManualSubmission && (
            <Fragment key="upload manually from system">
              <Box fontSize={16}>-- OR --</Box>
              <input
                ref={uploadRef}
                type="file"
                accept=".mp4"
                onChange={onUploadVideo}
                style={{ display: "none" }}
              />
              <Box
                fontSize={16}
                onClick={uploadDirectly}
                disabled={loading}
                sx={{
                  textDecoration: "underline",
                  ":hover": { fontWeight: "600", cursor: "pointer" },
                }}
              >
                Upload Existing Video
              </Box>
            </Fragment>
          )}
        </Box>
        <Box
          sx={{
            display: "flex",
            flex: 1,
            flexDirection: "column",
            justifyContent: "center",
            margin: { xs: "0 10px", sm: "auto" },
          }}
        >
          {getInsturction("Important Instructions:", "h4")}
          {getInsturction("Shoot horizontally (landscape mode).")}
          {getInsturction(
            "Use an iPhone or a laptop / desktop computer and camera if available."
          )}
          {getInsturction("Set your camera at an appropriate angle/level.")}
          {getInsturction(
            "Ensure your entire body or the necessary part is clearly in frame, either seated or standing."
          )}
          {getInsturction(
            "Choose a well-lit, clutter-free space for recording."
          )}
          {getInsturction(
            "Prioritize sound quality; ensure your mic captures clear audio with minimal background noise or echo."
          )}
          <Typography variant="body2">Address the camera directly.</Typography>
        </Box>
      </Box>

      <Box>
        <Button
          variant="contained"
          color="primary"
          size="large"
          disableElevation
          onClick={onVideoSubmit}
          disabled={loading || !onSubmit}
        >
          {loading ? "Submitting..." : "Submit"}
        </Button>
      </Box>
    </Container>
  );
};
